import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    setInterval(() => {
      this.data.time--;
    }, 1000);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onClick(): void {
    let object=this;
    if("Are you sure you want to exit?"==object.data.message){
      // @ts-ignore
      window.location=window.location.origin;
    }
  }

  ngOnInit() {
  }

}
